import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader } from "../components/PageHeader";
import { ExternalLink } from "lucide-react";

const defaultLinks = [
  { name: "BNPB", description: "Badan Nasional Penanggulangan Bencana", url: "https://bnpb.go.id" },
  { name: "BMKG", description: "Badan Meteorologi, Klimatologi, dan Geofisika", url: "https://bmkg.go.id" },
  { name: "Badan Geologi", description: "Kementerian ESDM — Badan Geologi", url: "https://vsi.esdm.go.id" },
  { name: "Basarnas", description: "Badan Nasional Pencarian dan Pertolongan", url: "https://basarnas.go.id" },
  { name: "Pemkab Kayong Utara", description: "Portal resmi Pemerintah Kabupaten Kayong Utara", url: "https://kayongutarakab.go.id" },
  { name: "BPBD Provinsi Kalbar", description: "BPBD Provinsi Kalimantan Barat", url: "https://bpbd.kalbarprov.go.id" },
  { name: "InaRISK", description: "Portal penilaian risiko bencana BNPB", url: "https://inarisk.bnpb.go.id" },
  { name: "PMI", description: "Palang Merah Indonesia", url: "https://pmi.or.id" },
];

export default function Tautan() {
  const [links, setLinks] = useState([]);
  useEffect(() => {
    api.get("/links").then((r) => setLinks(r.data)).catch(() => {});
  }, []);
  const list = links.length ? links : defaultLinks;
  return (
    <div data-testid="tautan-page">
      <PageHeader title="Tautan Terkait" subtitle="Situs resmi lembaga dan instansi terkait penanggulangan bencana" />
      <section className="max-w-7xl mx-auto px-4 py-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {list.map((l) => (
          <a key={l.name} href={l.url} target="_blank" rel="noreferrer" className="group hover-lift border border-slate-200 bg-white rounded-xl p-6 hover:border-orange-400" data-testid={`tautan-${l.name.toLowerCase().replace(/\s/g, "-")}`}>
            <div className="flex items-start justify-between">
              <h3 className="font-heading font-bold text-slate-900 group-hover:text-orange-600 transition-colors">{l.name}</h3>
              <ExternalLink size={15} className="text-slate-400 group-hover:text-orange-500" />
            </div>
            {l.description && <p className="text-sm text-slate-500 mt-2">{l.description}</p>}
            <p className="font-mono text-xs text-sky-600 mt-3 break-all">{(l.url || "").replace("https://", "").replace("http://", "")}</p>
          </a>
        ))}
      </section>
    </div>
  );
}
